export enum CareType {
  Preoperative = "Předzákroková",
  Postoperative = "Pozákroková",
}
